import { isAxiosError } from "axios";
import i18n, { t } from "i18next";
import axios from "../lib/axios";
import { CalculateWorkingTimeSummaryResult } from "../types";

export const sendCalculateWorkingTimeSummaryRequest = async (
  year: number,
  month: number,
  companyId?: number,
): Promise<CalculateWorkingTimeSummaryResult[]> => {
  try {
    const { data } = await axios.post<CalculateWorkingTimeSummaryResult[]>(
      `/api/calculate-working-time-summary`,
      {
        summaryForYear: year,
        summaryForMonth: month,
      },
      {
        params: {
          companyId,
        },
        headers: {
          "Accept-Language": i18n.language,
        },
      },
    );

    return data;
  } catch (error) {
    let message = t("common.unknownErrorOccurred");

    if (isAxiosError(error)) {
      if (error.response) {
        if (error.response.status === 403) {
          message = t("noPermissions");
        } else if (error.response.data) {
          if (
            "errors" in error.response.data &&
            Array.isArray(error.response.data.errors) &&
            error.response.data.errors.length > 0 &&
            typeof error.response.data.errors[0] === "object" &&
            "message" in error.response.data.errors[0]
          ) {
            message = error.response.data.errors[0].message;
          } else if ("message" in error.response.data) {
            message = error.response.data.message;
          }
        }
      } else if (error.request) {
        message = t("common.noResponseFromServer");
      }
    }

    throw new Error(message);
  }
};
